<template>
  <div class="content">
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 附加单据
      </h3>
        <div class="imp-class">
            <OutEntrepot :outEntrepotId="outEntrepotId" />
        </div>
      <!--<div class="tu-class">

        <el-form :model="formData2" label-position="left" label-width="80px" size="default">

          <div class="table-container">
            <h2 align="center">出库单</h2>
              <div class="table-footer-info">
                  <span class="footer-info-item"><strong>客户名称：{{formData2.customerName}}</strong></span>
                  <span class="footer-info-item"><strong>开单日期：{{parseTime(formData2.createTime,'{y}/{m}/{d}')}}</strong></span>
                  <span class="footer-info-item"><strong>单号：{{formData2.number}}</strong></span>
              </div>
              &lt;!&ndash;<span>
                  <strong>客户名称：</strong>{{formData2.customerName}}
                  <strong>开单日期：</strong>{{parseTime(formData2.createTime,'{y}/{m}/{d}')}}
                  <strong>单号：</strong>{{formData2.number}}
              </span>&ndash;&gt;

              <table class="table-layout">
              <tbody>
              <tr>
                <td class="table-cell">序号</td>
                <td class="table-cell">品名</td>
                <td class="table-cell">数量</td>
                <td class="table-cell">单位</td>
                <td class="table-cell">价格</td>
                <td class="table-cell">货款</td>
                <td class="table-cell">备注</td>
              </tr>

              <tr v-for="(content, index) in formData2.contentList" :key="index">
                <td class="table-cell">{{index+1}}</td>
                <td class="table-cell">
                  <input type="text" v-model="content.categoryName" class="text-input">
                </td>
                <td class="table-cell">
                  <input type="text" v-model.number="content.quantity" class="text-input">
                </td>
                <td class="table-cell">
                  <input type="text" v-model="content.units" class="text-input">
                </td>
                &lt;!&ndash;<td class="table-cell">
                  <input type="text" v-model="content.unitPrice" class="text-input">
                </td>
                <td class="table-cell">
                  <input type="text" v-model="content.paymentGoods" class="text-input">
                </td>&ndash;&gt;
                <td class="table-cell" colspan="3">
                  <input type="text" v-model="content.remark" class="text-input-left">
                </td>
              </tr>

              <tr>
                <td class="table-cell" colspan="2">合计</td>
                <td class="table-cell">
                    <input type="text" v-model="formData2.total" class="text-input">
                </td>
                <td class="table-cell" colspan="4">
                    <input type="text" v-model="formData2.noticeRemark" class="text-input">
                </td>
              </tr>
              <tr>
                <td class="table-cell">备注</td>
                <td class="table-cell" colspan="6"><input type="text" v-model="formData2.remark" class="text-input-left"></td>
              </tr>

              </tbody>
            </table>
              <div class="table-footer-info">
                  <span class="footer-info-item"><strong>制单：</strong></span>
                  <span class="footer-info-item"><strong>财务：</strong></span>
                  <span class="footer-info-item"><strong>仓库：</strong></span>
                  <span class="footer-info-item"><strong>客户签名：</strong></span>
              </div>
          </div>

        </el-form>

      </div>-->

    </div>

    <div class="lct-class num1-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 流程图
      </h3>
      <div class="tu-class">
        <p v-html="str" class="p-class">{{str}}</p>
      </div>
    </div>
    <div class="lct-class">
      <h3 class="detail-h3">
        <i class="el-icon-monitor"></i> 流程历史跟踪
      </h3>
      <el-table :data="tableData" border>
        <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="activityName" label="名称" align="center"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" align="center"></el-table-column>
        <el-table-column prop="endTime" label="结束时间" align="center"></el-table-column>
        <el-table-column prop="assignee" label="负责人" align="center"></el-table-column>
        <el-table-column prop="status" label="处理结果" align="center"></el-table-column>
        <el-table-column prop="reason" label="处理意见" align="center"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
  import { processInstanceImage } from "@/api/api.js";//流程图
  import { historicActivityInstance } from "@/api/api.js";//记录展示
  import { outEntrepotDetailById } from "@/api/api.js";//附加单据
  import OutEntrepot from "./info/OutEntrepot.vue";
  export default {
    //name: "outEntrepotFlowView",
    components: {OutEntrepot},
    data() {
      return{
        id: this.$route.query.id,
        processId: this.$route.query.processId,
        outEntrepotId: this.$route.query.id,
        str:"",
        formData: {},
        formData2: {},
        tableData:[]
      }
    },
    methods: {
      //流程图，办理经过
      initData(){
        if (this.processId) {
          let params ={processInstanceId: this.processId};
          processInstanceImage(params).then(res=>{
            this.str = res.data
          });
          historicActivityInstance(params).then(res=>{
            if (res.data.code == 200) {
              this.tableData = res.data.data;
              this.tableData.map((item,index)=>{
                item.ids = index + 1;
              })
            }
          });
        }
        //出库单
        let params2 = {id: this.id};
        outEntrepotDetailById(params2).then(res=>{
          if (res.data.code == 200) {
            this.formData2 = res.data.data;
          }
          if (!this.formData2) {
            this.formData2 = {
              id: null,
              customerName: null,
              billingDate: null,
              remark: null,
              documenter: null,
              financial: null,
              entrepot: null,
              number: null,
              customerSignature: null,
              total: null,
              status: null,
              shipmentId: null,
              flowId: null,
              contentList: [
                {
                  id: null,
                  categoryName: null,
                  quantity: null,
                  units: null,
                  unitPrice: null,
                  paymentGoods: null,
                  remark: null,
                  outEntrepotId: null
                },
                {
                  id: null,
                  categoryName: null,
                  quantity: null,
                  units: null,
                  unitPrice: null,
                  paymentGoods: null,
                  remark: null,
                  outEntrepotId: null
                },
                {
                  id: null,
                  categoryName: null,
                  quantity: null,
                  units: null,
                  unitPrice: null,
                  paymentGoods: null,
                  remark: null,
                  outEntrepotId: null
                },
                {
                  id: null,
                  categoryName: null,
                  quantity: null,
                  units: null,
                  unitPrice: null,
                  paymentGoods: null,
                  remark: null,
                  outEntrepotId: null
                }
              ]
            }
          }
        })
      },

    },
    created() {
      //this.processId =  this.$route.query.processId;
      //this.id =  this.$route.query.id;
    },
    mounted() {
      this.initData()
    },
  };
</script>
<style scoped lang="less">
    .content {width: 98%}
    .imp-class{
        display: flex;
        justify-content: center;
    }
  .lct-class{
    .detail-h3 {
      font-size: 20px;
      color: #000000;
      padding-bottom: 30px;
      box-sizing: border-box;
    }
    .detail-h3 i {
      color: #5298ff;
    }
  }

  .el-row {
    //   margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 0px;
    //   min-height: 36px;
    border: 1px solid #4d4d4d;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 46px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
  }

  .grid-content-image {
    border-radius: 4px;
    min-height: 300px;
    padding: 10px;
    display: flex;
    justify-content: center; /* 水平居中 */
    align-items: center;
  }

  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  div.table-container {
    margin-top: 50px;
    margin-left: 220px;
    max-width: 1200px;
    padding: 20px;
    border-radius: 5px;
    border: 1px solid black;
    table.table-layout {
      table-layout: fixed;
      border-collapse: collapse;
      width: 1080px;

      td.table-cell {
        display: table-cell;
        height: 36px;
        border: 1px solid black;
        text-align: center;
      }
    }
  }
  .table-checkbox,
  .table-radio {
    display: table-cell;
    border: 1px solid black;
    text-align: left;
  }

  .add-button {
    margin-top: -340px;
    margin-right: -10px;
    float: right;
    position: relative;
  }
  .save {
    margin-top: 50px;
    margin-left: 750px;
    position: relative;
  }
  .text-input {
    width: 100%;
    height: 100%;
    padding: 5px;
    border: 1px #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: center;
  }
  .text-input-left {
    width: 100%;
    height: 100%;
    padding: 5px;
    border: 1px #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: left;
  }
  .radio-input {
    vertical-align: middle;
    margin-top: -2px;
    margin-bottom: 1px;
  }
  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 138px;
    height: 138px;
  }
  .avatar-uploader:hover {
    border-color: #409eff;
  }
  .svg-avatar-uploader-icon {
    font-size: 28px;
    width: 60px;
    height: 60px;
    line-height: 18px;
    text-align: center;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 138px;
    height: 138px;
    // line-height: 88px;
    text-align: center;
  }
  .avatar {
    width: 138px;
    height: 138px;
    display: block;
  }
  .table-footer-info {
      margin-top: 6px;
      display: flex;
      gap: 120px;
  }
  .info-item {
      font-size: 18px;
  }
  .footer-info-item{
      font-size: 15px;
  }

  .lct-class{
    padding-bottom: 50px;
    .detail-h3 {
      font-size: 20px;
      color: #000000;
      padding-bottom: 30px;
      box-sizing: border-box;
    }
    .detail-h3 i {
      color: #5298ff;
    }
    .nr-class{
      margin-top: 20px;
      margin-left: 10px;
    }
    .yjp-class{
      margin-top: 20px;
    }
  }
</style>


